/**
 * Insctance of EffectCommand
 * @class EffectCommand
 */
import uuid from 'uuid/v4'
export default class AddCommand {
  /**
   * Constructor
   */
  constructor(target, element) {
    this.label = 'add'
    this.target = target
    this.element = element
    this.element.uid = uuid()
    this.element.layer = (this.target.canvas._objects.length - 1) + 1
    this.element.stateProperties = ['left', 'top', 'angle', 'scaleX', 'scaleY', 'fill', 'width', 'height']
  }

  execute() {
    const canvas = this.target.canvas
    canvas.viewportCenterObject(this.element)
    canvas.add(this.element).setActiveObject(this.element)
    this.element.saveState()
    this.target.grid.updateLayer(this.target)
    this.target.emit('addItem', this.element)
  }

  undo() {
    const canvas = this.target.canvas
    canvas.remove(this.element)
  }
}



// WEBPACK FOOTER //
// ./src/model/pixel/command/AddCommand.js